import { datadogRum } from '@datadog/browser-rum';

import { ENVIRONMENT, RELEASE_VERSION } from '@funnels/constants';

export interface User {
  id?: string;
  email?: string;
  name?: string;
  [key: string]: unknown;
}
export type Source = 'source' | 'custom' | 'network' | undefined;
export interface Logger {
  enableLogging(): boolean;
  init(): void;
  addError(error: any, context?: object | undefined, source?: Source): void;
  addContext(key: string, value: any): void;
  setContext(newContext: object): void;
  setUser(user: User): void;
}

const enableLogging = () => {
  return process.env.REACT_APP_ENABLE_MONITORING === 'true';
};

const nullLogger: Logger = {
  enableLogging,

  init() {
    return;
  },

  addError(_) {
    return;
  },

  addContext() {
    return;
  },

  setContext() {
    return;
  },

  setUser() {
    return;
  },
};

const loggerFactory: () => Logger = () => {
  if (!enableLogging()) {
    return nullLogger;
  }

  const release = RELEASE_VERSION || undefined;

  return {
    enableLogging,

    init() {
      if (enableLogging()) {
        datadogRum.init({
          applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID || 'c919b595-99da-41b2-bb87-a9a6ab1376e0',
          clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || 'pub254e50234b5e73df403a822565637b37',
          site: process.env.REACT_APP_DATADOG_SITE || 'datadoghq.com',
          service: 'funnels',
          env: ENVIRONMENT,
          version: release,
          sessionSampleRate: 100,
          sessionReplaySampleRate: 0,
          trackUserInteractions: false,
          allowedTracingUrls: process.env.REACT_APP_API_BASE_URL ? [process.env.REACT_APP_API_BASE_URL] : [],
          defaultPrivacyLevel: 'mask',
        });
      }
    },

    addError(error: any, context: object | undefined = undefined) {
      if (!enableLogging() || (error.response && error.response.status === 404)) {
        return;
      }
      datadogRum.addError(error, context);
    },

    addContext(key, value) {
      if (!enableLogging() || !key || !value) {
        return;
      }
      datadogRum.setGlobalContextProperty(key, value);
    },

    setContext(newContext: object) {
      if (!enableLogging() || !newContext) {
        return;
      }
      datadogRum.setGlobalContext(newContext);
    },

    setUser(user: User) {
      if (!enableLogging() || !user) {
        return;
      }

      datadogRum.setUser(user);
    },
  };
};

export const datadogUtil = loggerFactory();
